
export default function BookingInfo() {
  return (
    <div className="space-y-8">
      <div className="bg-emerald-50 rounded-lg p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">Booking Information</h3>
        
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 mb-2">Check-in & Check-out</h4>
            <p className="text-gray-600">Check-in: 3:00 PM | Check-out: 11:00 AM</p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-2">Cancellation Policy</h4>
            <p className="text-gray-600">Free cancellation up to 48 hours before check-in. Cancellations within 48 hours are subject to a 50% charge.</p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-2">What's Included</h4>
            <ul className="text-gray-600 space-y-1">
              <li>• Luxury glamping accommodation</li>
              <li>• Premium bedding and linens</li>
              <li>• Private bathroom facilities</li>
              <li>• Welcome refreshments</li>
              <li>• Access to hiking trails</li>
              <li>• Complimentary WiFi</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-2">Additional Services</h4>
            <ul className="text-gray-600 space-y-1">
              <li>• Gourmet meal packages available</li>
              <li>• Guided nature tours</li>
              <li>• Spa treatments</li>
              <li>• Adventure activities</li>
              <li>• Private chef services</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="bg-gray-50 rounded-lg p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">Need Help?</h3>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-white"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Call Us</p>
              <p className="text-gray-600">(256) 268-7146</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
              <i className="ri-mail-line text-white"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Email Us</p>
              <p className="text-gray-600">Create@oedtinyhomebuilders.com</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
              <i className="ri-time-line text-white"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Business Hours</p>
              <p className="text-gray-600">Mon-Fri: 9:00 AM - 6:00 PM<br />Sat-Sun: 10:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
